import { jsx as _jsx } from 'react/jsx-runtime.js';
import { Button } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
export const LoginButton = ({ onClick, isLoading, ddActionName, buttonText, }) => {
    const { t } = useTranslation();
    return (_jsx(Button, { "data-dd-action-name": ddActionName, "data-testid": "login-submit-btn", autoFocus // it is used to focus on the button first instead of the input fields
        : true, variant: "primary", a11yLabel: t('loginregistration.login.button.a11yLabel'), type: "submit", onClick: onClick, isLoading: isLoading, isFullWidth: true, size: ['medium'], children: buttonText ?? t('loginregistration.login.button') }));
};
//# sourceMappingURL=LoginButton.js.map